import Moment from 'moment';

export const timeout = (ms, promise) => {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(new Error('TIMEOUT'));
    }, ms);

    promise
      .then((value) => {
        clearTimeout(timer);
        resolve(value);
      })
      .catch((reason) => {
        reject(reason);
        clearTimeout(timer);
      });
  });
};

export const formatDateToBR = (date) => {
  if (!date) return '';
  return Moment(date).format('DD/MM/YYYY');
};

export function formatDateTime(dateString, timeString) {
  const dateTimeString = `${dateString}T${timeString}`;
  return Moment(dateTimeString).format('YYYY-MM-DDTHH:mm:ss.SSSSSS');
}

export const formatDateTo = (date, format = 'YYYY-MM-DD') => {
  if (!date) return '';
  return Moment(date).format(format);
};

export const formatDateToBRWithHour = (date) => {
  if (!date) return '';
  return Moment(date).format(
    'DD/MM/YYYY, [às] HH:mm:ss'
  );
};

export const formatHoursToBR = (date) => {
  if (!date) return '';
  return Moment(date ? new Date(date) : new Date()).format('HH:mm:ss');
};

export const formatHoursToBRWithoutSeconds = (date) => {
  if (!date) return '';
  return Moment(date ? new Date(date) : new Date()).format('HH:mm');
};

export const formatDateWithHour = () => Moment(new Date()).format('DD/MM/YYYY HH:mm:ss');
export const formatStringToDateTime = (date) => Moment(date).format('DD/MM/YYYY HH:mm:ss');

export const formatDateWithoutTime = (dateTime) => {
  if (!dateTime) return '';
  return Moment(dateTime).format(Moment.HTML5_FMT.DATE);
};

export function stringToDate(dataString) {
  if(!dataString) return '';
  return dataString.split('T')[0];
}

export function formatDateImage(date) {
  if(!date) return 'Sem data'
  const partes = date.split('-');
  const dataHora = partes.slice(1).join('-').split('.')[0];
  return formatDateToBRWithHour(dataHora);
}

export function formatDateAttachment(date) {
  if (!date) return 'Sem data';
  return formatDateToBRWithHour(date);
}

